import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import { H5, P, UL } from '../../../AbstractElements';
import SocialAuth from './SocialAuth';

const SignInWith = ({ t }) => {
    return (
        <Fragment>
            <P>{t("Don't have account ?")}
                <Link className='ms-2' to={'/register'}>{t("Create Account")}</Link>
            </P>
        </Fragment>
    );
};
export default SignInWith;
